<template>
  <section>
    <UpdateFinancialAccountBalancesBanner
      v-if="authUser.permission.canAccessPlaid && currentEstate?.jurisdiction?.isInUnitedStates"
      :data-e2e="FinancialAccountCypressAttribute.views.BALANCES_BANNER"
    />
  </section>
</template>

<script>
import UpdateFinancialAccountBalancesBanner from '/@/modules/financialaccount/components/UpdateFinancialAccountBalancesBanner.vue';
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import { FinancialAccountCypressAttribute } from '@/modules/financialaccount/constants/FinancialAccountCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'AppFooter',
  mixins: [HasCurrentEstateMixin, HasAuthUserMixin],
  components: {
    UpdateFinancialAccountBalancesBanner
  },
  static: {
    FinancialAccountCypressAttribute
  }
};
</script>
